import { ComponentStyleConfig } from '@chakra-ui/react';

export const Badge: ComponentStyleConfig = {
  defaultProps: {
    variant: 'ghost',
  },

  baseStyle: {
    fontFamily: 'mono',
    fontWeight: 500,
    fontSize: '11px',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    borderRadius: '999px',
    px: '10px',
    py: '4px',
  },

  variants: {
    ghost: {
      bg: 'accent.dim',
      color: 'accent.500',
      borderWidth: '1px',
      borderColor: 'accent.line',
    },
    quiet: {
      bg: 'bg.surface',
      color: 'text.muted',
      borderWidth: '1px',
      borderColor: 'line.subtle',
    },
  },
};
